module.exports = __webpack_public_path__ + "static/media/ad-hoc-reporting.4da6abc9.svg";